<script>
  import { onMount } from "svelte";
  import Card from "./Card.svelte";
  import {
    SetupStore
  } from "../stores/gameStore";
  import { ItemMeta } from "../../constants/items";
  import {
    getTextsSkills,
    getTextsPotionSkills
  } from "../../constants/allTexts";

  export let card, id, width, active, location = 'none';

  let idLocation = ''.concat(id, '_', location);
  const textPotion = _('Potion');
  const textsSkills = getTextsSkills();
  const textsPotionSkills = getTextsPotionSkills();
  const textNotInFight = _('Can´t be used in a fight');

  onMount(() => {
    createTooltips();
  });

  let trackChanges2 = id;
  let delayTimeout;
  $: if ((trackChanges2 !== id)) {
    trackChanges2 = id;

    // Clear any existing timeout to avoid multiple triggers
    if (delayTimeout) {
      clearTimeout(delayTimeout);
    }

    window.GAME.removeTooltip(idLocation);
    idLocation = ''.concat(id, '_', location);
    
    // Delay the tooltip creation
    delayTimeout = setTimeout(() => {
      createTooltips();
    }, 100);
  }

  $: cardData = $SetupStore.data.cards[id];
  function createTooltips() {
    const scaleFactor = 0.65;
    const backgroundWidth = 1662 * scaleFactor;
    const backgroundHeight = 1284  * scaleFactor;
    const cardsX = 6; // Width of each card in Amount of Cards
    const cardsY = 3; // Height of each card in Amount of Cards
    let cardWidth = backgroundWidth / cardsX;
    let cardHeigth = backgroundHeight / cardsY;
    window.GAME.addTooltipHtml(
      idLocation,
      `<div style="display:flex; flex-direction:column; margin: 1rem;">
        <div 
          style="
            display: flex; 
            justify-content: center;">
          <div 
            <div 
              style="
                background-image: url('${g_gamethemeurl}img/CardsPotions.jpg');
                background-position: -${cardData.offset[1] * cardWidth}px -${cardData.offset[0] * cardHeigth}px;
                width: ${cardWidth}px;
                height: ${cardHeigth}px;
                background-size: ${backgroundWidth}px ${backgroundHeight}px;
                margin-bottom: 1rem;
                border-radius: 15px;
                filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0, 0.5));
              ">
          </div>
        </div>
        <div style="display:flex; flex-direction:column; max-width: 200px; word-wrap: break-word;">
          <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem;">
            <div class="headline">${textPotion}</div>
            </div>
            <hr style="width:100%;"/>
            ${card.special ? `<div>${textsPotionSkills[card.special]}</div>` : ""} ${card.notInFight ? `<div>(${textNotInFight})</div>` : ""}
            <div style="display:grid; grid-template-columns:auto 1fr; grid-column-gap:0.5rem">
          ${(cardData?.combat?.skills || []).map((c) => `<div>${c.value !== undefined ? c.value + " " : ""}</div><div>${textsSkills[c.type]?.name}</div>`).join("")}
            </div>
          </div>
      </div>`
    );
  }
</script>

<!-- <pre>{JSON.stringify(id, null, 2)}</pre> -->
<div class:active={active == 1}>
  <Card {...$$props} {width} {card} id={idLocation} />
</div>

<style>
  @keyframes pulse {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }

  .active {
    filter: drop-shadow(0px 0px 10px #5c258f44) drop-shadow(0px 0px 3px #994ae2);
    outline: 2px solid #ffc9f7;
    border-radius: 5px;
  }

  .active::before {
    content: ""; /* Required for the pseudo-element */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(238, 102, 250, 0.295); /* Example color for the overlay */
    animation: pulse 4s infinite; /* Apply the pulse animation */
    border-radius: inherit; /* Match the border-radius of the parent */
    pointer-events: none; /* Ensure it doesn’t block interactions */
  }
</style>
